import { axiosConfig } from './axios-config.js'
export const chiline = {
  // 取得裝置清單
  get: (id, token) => axiosConfig.get(`/api/chiline/${id || ''}`, token),

  // 更新裝置資訊
  update: (id, data, token) => axiosConfig.patch(`/api/chiline/${id}`, data, token)
}
